import React from 'react';

const Stats = ({ 
  stats = [
    { value: '500+', label: 'Certifications Managed' },
    { value: '98%', label: 'Client Satisfaction' },
    { value: '50+', label: 'ISO Standards' },
    { value: '24/7', label: 'Support Available' },
  ],
  columns = 4,
  className = '' 
}) => {
  const columnClasses = {
    2: 'grid-cols-2',
    3: 'grid-cols-3',
    4: 'grid-cols-2 md:grid-cols-4',
  };

  return (
    <div className={`grid ${columnClasses[columns] || columnClasses[4]} gap-8 ${className}`}>
      {stats.map((stat, index) => (
        <div key={index} className="text-center">
          <div className="text-3xl md:text-4xl font-bold text-primary mb-2">
            {stat.value}
          </div>
          <div className="text-sm text-muted-foreground">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

Stats.builderConfig = {
  props: {
    columns: {
      type: 'select',
      label: 'Columns',
      default: 4,
      options: [
        { value: 2, label: '2 Columns' },
        { value: 3, label: '3 Columns' },
        { value: 4, label: '4 Columns' },
      ],
    },
  },
};

export default Stats;
